import { VuexState, Invite, Member } from '@/common/OrgAdmin';

import axios from 'axios';
import uuid from 'uuid/v4';

const state: VuexState = {
     members: [],
     invites: [],
     selectedInvite: undefined,
     selectedMember: undefined,
};

const getters = {};

const mutations = {
     setInvites(state: VuexState, payload) {
          state.invites = payload;
     },
     setMembers(state: VuexState, payload) {
          state.members = payload;
     },
     setSelectedInvite(state: VuexState, payload) {
          state.selectedInvite = payload;
     },
     setSelectedMember(state: VuexState, payload) {
          state.selectedMember = payload;
     },
};

const actions = {
     clearData({ commit }: any): void {
          commit('setInvites', []);
          commit('setMembers', []);
          commit('setSelectedInvite', undefined);
          commit('setSelectedMember', undefined);
     },
     async getAdminAccounts({ commit }: any): Promise<void> {
          try {
               const getAccounts = await axios({
                    method: 'GET',
                    url: process.env.VUE_APP_API_URI + '/organizations',
               });

               commit('setInvites', getAccounts.data.invitees);
               commit('setMembers', getAccounts.data.members);
          } catch (e) {
               throw new Error(e.response.data.error);
          }
     },
     async getInvite({ commit }: any, email: string): Promise<void> {
          // Do Axios call to add data
          try {
               const getInvite = await axios({
                    method: 'GET',
                    url:
                         process.env.VUE_APP_API_URI +
                         '/organizations?invite_email=' +
                         encodeURIComponent(email),
               });

               commit('setSelectedInvite', getInvite.data);
          } catch (e) {
               throw new Error(e.response.data.error);
          }
     },
     async getUser({ commit }: any, sub: string): Promise<void> {
          // Do Axios call to add data
          try {
               const getUser = await axios({
                    method: 'GET',
                    url:
                         process.env.VUE_APP_API_URI +
                         '/organizations?sub=' +
                         encodeURIComponent(sub),
               });

               commit('setSelectedMember', getUser.data);
          } catch (e) {
               throw new Error(e.response.data.error);
          }
     },
     async saveUser({ commit }: any, payload: Member): Promise<boolean> {
          // Do Axios call to add data
          try {
               const saveUser = await axios({
                    method: 'POST',
                    url: process.env.VUE_APP_API_URI + '/organizations',
                    data: {
                         user: payload,
                    },
               });
               return true;
          } catch (e) {
               throw new Error(e.response.data.error);
          }
     },
     async saveInvite({ commit }: any, payload: Invite): Promise<boolean> {
          // Do Axios call to add data
          try {
               const saveInvite = await axios({
                    method: ' ',
                    url: process.env.VUE_APP_API_URI + '/organizations',
                    data: {
                         invite: payload,
                    },
               });
               return true;
          } catch (e) {
               throw new Error(e.response.data.error);
          }
     },
};

export { state, getters, mutations, actions };
